import { Injectable } from '@angular/core';
import { UpgradeModule } from '@angular/upgrade/static';
import { DocViewHandler, DocViewDocType } from '@fry-it/risr-features/reports';

@Injectable()
export class KaizenDocViewHandler implements DocViewHandler {
    constructor(private readonly upgrade: UpgradeModule) {}

    openPreview(docType: DocViewDocType, id: string): void {
        const $injector = this.upgrade.$injector;
        if (!$injector) {
            console.warn('AngularJS injector not available');
            return;
        }

        switch (docType) {
            case 'event': {
                const Events = $injector.get('EventsService');
                const Event = $injector.get('EventFactory');
                const Auth = $injector.get('AuthService');
                const Localization = $injector.get('LocalizationService');
                const Profile = $injector.get('ProfileService');

                // Ensure date formats are initialised (they may not be if
                // the user navigated directly to an Angular route).
                const ensureLocalization = Localization.dateFormats
                    ? Promise.resolve()
                    : Profile.findOrganisation().then((org: any) =>
                          Localization.loadDateTimeFormats(org)
                      );

                ensureLocalization
                    .then(() => Events.findFor(id))
                    .then((data: any) => {
                        const isLocal = data.doc.user === Auth.currentUser();
                        const event = new Event(data.doc, { isLocal });
                        return event.init(data.doc);
                    })
                    .then((event: any) => {
                        event.openEventPreview();
                    });
                break;
            }
            case 'user':
                window.location.href = `/summary/${encodeURIComponent(id)}`;
                break;
        }
    }

    getLink(docType: DocViewDocType, id: string): string[] {
        switch (docType) {
            case 'event': return ['/users/edit/events', id];
            case 'user': return ['/summary/', id];
            default: return ['/'];
        }
    }
}
